import { render, staticRenderFns } from "./OpenSavingsAccount.vue?vue&type=template&id=11a8ed7a"
import script from "./OpenSavingsAccount.vue?vue&type=script&lang=js"
export * from "./OpenSavingsAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports